import { Login, route } from './container';
import login from './reducer';

const reducer = { login };
export { Login, route, reducer };